import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./screens/Home";
import About from "./screens/About";
import UploadProd from "./screens/UploadProd";
import Contact from "./screens/Contact";
import MenuProd from "./screens/MenuProd";
import Product from "./components/Product";

import PaymentSuccess from "./screens/PaymentSuccess";
import PaymentFailure from "./screens/PaymentFailure";
import PaymentPending from "./screens/PaymentPending";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/upload_prod" element={<UploadProd />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/menu_prod/:category" element={<MenuProd />} />
        <Route path="/product/:id" element={<Product />} />
        <Route path="/success" element={<PaymentSuccess />} />
        <Route path="/failure" element={<PaymentFailure />} />
        <Route path="/pending" element={<PaymentPending />} />
      </Routes>
    </Router>
  );
};

export default App;
